<template><div><h1 id="mahnungen-protokoll" tabindex="-1"><a class="header-anchor" href="#mahnungen-protokoll"><span>Mahnungen Protokoll</span></a></h1>
<p>Mahnungen Protokoll — Mahnlauf einrichten</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>funtrade verfügt über Mahnfunktionen, die ein mehrstufiges Mahnen (Mahnstufe 1 - 4) ermöglichen. Jeder Auftrag, der in einem Mahnlauf erfasst wird, erhält einen Zähler, so dass jederzeit die Anzahl Mahnungen pro Faktura eines Debitors ersichtlich sind.</p>
<p>Da versprochene Spenden in Aufträgen betreibungsrechtlich nicht einforderbar sind, können diese von der Mahnung ausgeschlossen werden, so dass gegenüber dem Betreibungsamt ein klarer Beleg vorhanden ist.</p>
<p>Gute Kunden können auf Wunsch individuell gehandhabt werden. Ebenso unterstützt das System eine Spezialbehandlung von Offenen Forderungen, welche einen bestimmten Betrag überschreiten. Es ist z.B. möglich, ausstehende Kleinbeträge mit moderatem Text zu mahnen, bei grösseren Beträgen der selben Mahnstufe eine Betreibungsandrohung auszudrucken.</p>
<p>Sämtliche Einstellungen können in einem einzigen Fenster vorgenommen werden, das wie üblich auch als Protokoll der durchgeführten Mahnläufe dient.</p>
<p>Pfad: <code v-pre>Buchhaltung → Verarbeitungsläufe → Mahnwesen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Jobnummer</dt>
<dd>Job-Identifikationsnummer</dd>
<dt>Lauf</dt>
<dd>Laufnummer des Jobs</dd>
<dt>Status (kein Label)</dt>
<dd>Statusinformationen für den aktuellen Mahnlauf; nur Anzeige:
<table>
<thead>
<tr>
<th>Status</th>
</tr>
</thead>
<tbody>
<tr>
<td>Job erfasst; noch nicht verarbeitet; löschbar</td>
</tr>
<tr>
<td>Verarbeitung angefangen und abgebrochen</td>
</tr>
<tr>
<td>Job aufbereitet; noch nicht gedruckt</td>
</tr>
<tr>
<td>Job aufbereitet; Protokoll gedruckt</td>
</tr>
<tr>
<td>Job aufbereitet; Protokoll und Mahnungen gedruckt</td>
</tr>
<tr>
<td>Job erledigt</td>
</tr>
</tbody>
</table>
</dd>
<dt>Offene Posten</dt>
<dd>Auswahl des zu mahnenden Buchungstyps:
<table>
<thead>
<tr>
<th>Typ</th>
</tr>
</thead>
<tbody>
<tr>
<td>Warenverkauf</td>
</tr>
<tr>
<td>Sammelrechnung</td>
</tr>
<tr>
<td>Obligatorische Debi-Note</td>
</tr>
</tbody>
</table>
</dd>
</dl>
<p>Alle übrigen Buchungstypen können nicht gemahnt werden!</p>
<dl>
<dt>Mandant Buchhaltung</dt>
<dd>Mahnlauf für einen bestimmten Mandanten durchführen; Musseingabe</dd>
<dt>Mindestmahnbetrag</dt>
<dd>Fakturen werden erst ab diesem Betrag gemahnt</dd>
<dt>Fälligkeitsdatum</dt>
<dd>Pro Auftrag (bzw. mahnbaren Buchungstyp) wird in den <a class="link" href="ft.refdata.manbuch.html" title="Manuelle Buchung">Manuellen Buchungen</a> das Fälligkeitsdatum festgehalten. Der Mahnlauf fügt den Auftrag der Mahnliste hinzu, wenn das Fälligkeitsdatum weiter zurück liegt oder gleich dem hier eingetragenen Datum ist.</dd>
<dt>Merkmal nicht mahnen</dt>
<dd>Adressen mit diesem Merkmal im Mahnlauf ausschliessen</dd>
<dt>Daueraufträge mahnen?</dt>
<dd>Vorauszahlungen für Dauerauftrag mahnen?<br>Sollen normale Aufträge und Daueraufträge getrennt gemahnt werden, empfiehlt es sich, 2 Mahnläufe zu definieren - den ersten mit Parameter &quot;nein&quot;, den zweiten mit &quot;ja&quot; - und in dieser Reihenfolge nacheinander laufen zu lassen</dd>
</dl>
<p>Pro Mahnstufe werden ab hier im Protokoll verschiedene Bereiche definiert bzw. vom System festgehalten:</p>
<dl>
<dt>aufb.?</dt>
<dd>
<p>ja = n-te Mahnungen werden im Mahnlauf berücksichtigt</p>
</dd>
<dt>Schärfecode normal / ab CHF</dt>
<dd>
<p>Mahntexte, pro Mahnstufe zu definieren. Schärfecode normal wird benutzt, wenn der mahnbare Betrag kleiner als der Grenzbetrag ist. Wenn der mahnbare Betrag grösser oder gleich gross wie der Grenzbetrag ist, gilt der Schärfecode in der Spalte &quot;ab CHF&quot;.</p>
</dd>
<dt>Fälligkeit erhöhen</dt>
<dd>
<p>Pro Mahnstufe kann bestimmt werden, um wieviel Tage das Fälligkeitsdatum in den <a class="link" href="ft.refdata.manbuch.html" title="Manuelle Buchung">Manuellen Buchungen</a> erhöht werden soll. Dieses bestimmt, wann der Offene Posten frühestens das nächste Mal gemahnt wird. Beispiel: &quot;20&quot; erhöht das Fälligkeitsdatum ausgehend vom Datum des aktuellen Mahnlaufs plus 20 Tage</p>
</dd>
<dt>Spende-Storno</dt>
<dd>
<p>Wenn in einem Offenen Posten noch (betreibungsrechtlich nicht einforderbare) versprochene Spenden enthalten sind, sollen diese storniert werden? Wird üblicherweise erst in der letzten Mahnstufe eingesetzt</p>
</dd>
<dt>Anzahl Mahnungen</dt>
<dd>
<p>Nur Anzeige. Im Protokoll wird ausgewiesen, wieviele Mahnungen pro Mahnstufe im Lauf verarbeitet worden sind</p>
</dd>
<dt>Merkmal erfassen / nach Anzahl Mahnungen</dt>
<dd>
<p>Dieses Merkmal wird nach der n. Mahnung bei der entsprechenden Adresse verknüpft (z.B. &quot;schlechter Zahler&quot;)</p>
</dd>
<dt>Bestätigen ab Umsatz?</dt>
<dd>
<p>Damit Adressen mit hohem Umsatz nicht automatisch gemahnt werden, kann ab einem bestimmten Umsatzbetrag eine <a class="link" href="ft.refdata.mahnmanuellb.html" title="Mahnungen manuell bestätigen">manuelle Bestätigung</a> eingerichtet werden:</p>
<dl>
<dt>Total</dt>
<dd>Gesamtumsatz</dd>
<dt>Spenden</dt>
<dd>Umsatz Spende</dd>
<dt>Mitglieder</dt>
<dd>Umsatz Zusagenbeitrag</dd>
<dt>Warenkauf</dt>
<dd>Umsatz Warenkauf</dd>
<dt>Total</dt>
<dd>Gesamtumsatz</dd>
</dl>
</dd>
<dt>Druckdatum</dt>
<dd>
<p>Datum des Drucks, nur Anzeige</p>
</dd>
<dt>Druckdatei</dt>
<dd>
<p>Erstellte Druckdatei, nur Anzeige</p>
</dd>
<dt>Drucker</dt>
<dd>
<p>Verwendeter Drucker, nur Anzeige</p>
</dd>
<dt>Status/Lauf</dt>
<dd>
<p>Staus und Lauf des Jobs, nur Anzeige</p>
</dd>
<dt>Dokumentensatz</dt>
<dd>
<p>Definition des Dokumentensatzes</p>
</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="mahnungen-zahlen-vorbereiten" tabindex="-1"><a class="header-anchor" href="#mahnungen-zahlen-vorbereiten"><span>Mahnungen zählen, vorbereiten</span></a></h3>
<p>Die Daten werden für die Mahnungen vorbereitet und die Zahlen ermittelt. Diese Vorbereitung kann wiederholt gestartet werden (z.B. nach einer Parameterkorrektur).</p>
<h3 id="mahnungen-aufbereiten-protokoll-drucken" tabindex="-1"><a class="header-anchor" href="#mahnungen-aufbereiten-protokoll-drucken"><span>Mahnungen aufbereiten, Protokoll drucken</span></a></h3>
<p>Eingabe Protokollnummer. Der Fortschritt wird wie beim Zähllauf angezeigt. Die durchgeführten Datenänderungen werden im Protokoll angezeigt.</p>
<h3 id="mahnungen-drucken" tabindex="-1"><a class="header-anchor" href="#mahnungen-drucken"><span>Mahnungen drucken</span></a></h3>
<p>Die im Job aufbereiteten Mahnungen werden ausgedruckt (siehe <RouteLink to="/referenz/refs/ft.refproc.mahndrucken.html" title="Mahnung drucken">Mahnungen drucken</RouteLink></p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.manbuch.html" title="Manuelle Buchung">Manuelle Buchungen</RouteLink></p>
</div></template>


